import campaignActivityModal from './campaignActivityModal.html';

export default class CampaignDetailController {
    constructor(
        $scope,
        $state,
        $stateParams,
        $ionicLoading,
        $ionicPopup,
        ApiCampaigns,
        ApiContacts,
        ApiTasks,
        MessageBox,
        $filter,
        $rootScope,
        filterHistory,
        $ionicScrollDelegate,
        $ionicModal,
        FileSaver,
        $cordovaToast,
        sentEmailPopup,
        ApiUser
    ) {
        this.FileSaver = FileSaver;
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$state = $state;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiContacts = ApiContacts;
        this.ApiTasks = ApiTasks;
        this.MessageBox = MessageBox;
        this.activeTab = 'detail';
        this.$filter = $filter;
        this.translateFilter = $filter('translate');
        this.filterHistory = filterHistory;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.$cordovaToast = $cordovaToast;

        this.campaign = null;
        this.campaigns = [];
        this.selections = null;
        this.contacts = null;

        this.campaignId = $stateParams.campaignId;
        this.levelOfInterest = $stateParams.level;
        this.childrenIds = [];
        this.sortOrder =
            $stateParams.sortOrder || 'contactInfo.contact.lastName'; // sort using contact name by default
        this.sortDirection = false;
        this.loading = []; // track data loading
        this.activityReportData = [];
        this.isActivityReport = false;
        this.sentEmailPopup = sentEmailPopup;

        if (this.levelOfInterest) {
            this.activeTab = 'contacts';
        }

        var self = this;
        $rootScope.$on(
            '$stateChangeStart',
            function (event, toState, toParams, fromState, fromParam) {
                if (self.closeModal != null) self.closeModal();
            }
        );

        this.activityReportModal = $ionicModal.fromTemplate(
            campaignActivityModal,
            {
                scope: $scope,
            }
        );
        ApiUser.getUser().then((user) => {
            this.user = user;
        });
    }

    init() {
        let self = this;
        self.getCampaign();
        self.getCurrencyList();
        self.resolveTaskPromise();
        self.getAllChildCampaigns();
        self.getCampaignChildren();
        self.getChartData();

        this.ApiCampaigns.getActivityReport(this.campaignId).then((data) => {
            this.isActivityReport = data.length > 0;
        });
    }

    reloadChildren() {
        this.getCampaign();
        this.getCampaignChildren();
    }

    resolveTaskPromise() {
        this.taskParameters = { campaignIds: [this.campaignId] };
        this.updateCampaignIdInSavedFilter();
    }

    updateCampaignIdInSavedFilter() {
        let savedFilter = this.filterHistory.readFilter('campaign-detail');
        if (
            savedFilter &&
            savedFilter.campaignIds &&
            this.campaignId != savedFilter.campaignIds[0]
        ) {
            savedFilter.campaignIds = [this.campaignId];
            this.filterHistory.saveFilter(savedFilter, 'campaign-detail');
        }
    }

    getCampaign() {
        let self = this;
        this.showLoading();
        this.ApiCampaigns.getCampaign(this.campaignId)
            .then((campaign) => {
                self.campaign = campaign || {};
                self.campaign.hideCheckedItems = true; // hide the checked items in the contacts modal
                if (self.campaign.parent && self.levelOfInterest) {
                    self.activeTab = 'campaigns';
                }
            })
            .finally(function () {
                self.hideIonicLoading();
            });
    }
    getCampaignChildren() {
        this.showLoading();
        this.ApiCampaigns.getCampaignChildren(this.campaignId).then(
            (children) => {
                this.childCampaigns = children || [];
                this.getChildrenIds();
                this.hideIonicLoading();
            },
            function (error) {
                console.error(error);
            }
        );
    }

    getChildrenIds() {
        this.childrenIds = [];
        this.childCampaigns.map((c) => {
            this.childrenIds.push(c.campaignId);
        });
    }

    getAllChildCampaigns() {
        this.showLoading();
        this.ApiCampaigns.getAllChildCampaigns().then((campaigns) => {
            this.campaigns = campaigns;
            this.hideIonicLoading();
        });
    }

    getCurrencyList() {
        this.showLoading();
        this.ApiCampaigns.retrieveCurrencyList().then((currencyObjects) => {
            this.currencies = currencyObjects.data;
            this.hideIonicLoading();
        });
    }

    getChartData() {
        this.showLoading();
        this.ApiCampaigns.getChartData(this.campaignId).then((data) => {
            this.populateCampaignDetails(data);
            this.chartData = data || {};
            this.hideIonicLoading();
        });
    }

    populateCampaignDetails(campaign) {
        let campaigns = [campaign];
        let self = this;
        angular.forEach(campaigns, (campaign) => {
            if (campaign.campaign) {
                campaign.currency = angular.copy(
                    self.getCurrencySymbol(campaign.campaign.campaignCurrency)
                );
                campaign.campaign.investmentLabels = [
                    self.translateFilter('MISSING_INVESTMENT'),
                    self.translateFilter('POTENTIAL_INVESTMENT'),
                    self.translateFilter('COMMITED_INVESTMENT'),
                ];
                campaign.campaign.investmentData = [];
                campaign.campaign.investmentData.push(
                    this.calculateMissingInvestment(campaign.campaign)
                );
                campaign.campaign.investmentData.push(
                    campaign.campaign.promisedInvestment
                );
                campaign.campaign.investmentData.push(
                    campaign.campaign.confirmedInvestment
                );

                if (campaign.numOfContactsByLevelOfInterest) {
                    campaign.numOfContactsByLevelOfInterest.lOILabels = [
                        'No',
                        'Selected',
                        'Pending',
                        'Low',
                        'Resubmission Later',
                        'Decision via Gatekeeper / Parent / Advisor',
                        'General',
                        'MP Meeting',
                        'Strong interest',
                        'Due Diligence',
                        'Soft Circled',
                        'Committed',
                    ];
                    campaign.numOfContactsByLevelOfInterest.lOIData = [];
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.NO
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.SELECTED
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.PENDING
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.LOW
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest
                            .RESUBMISSION_LATER
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest
                            .DECISION_VIA_GATEKEEPER_ADVISOR_PARENT
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.GENERAL
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.MP_MEETING
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.STRONG_INTEREST
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.DUE_DILIGENCE
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.SOFT_CIRCLED
                    );
                    campaign.numOfContactsByLevelOfInterest.lOIData.push(
                        campaign.numOfContactsByLevelOfInterest.COMMITED
                    );
                }
            }
        });
    }

    calculateMissingInvestment(campaign) {
        let missingInvestment =
            campaign.targetInvestment -
            campaign.promisedInvestment -
            campaign.confirmedInvestment;
        if (missingInvestment < 0) {
            return 0;
        } else {
            return missingInvestment;
        }
    }

    promptCampaignDelete($event) {
        $event.preventDefault();
        let dialogResult = this.$ionicPopup.confirm({
            title: this.$filter('translate')('DELETE_CAMPAIGN'),
            template: this.$filter('translate')('DELETE_CAMPAIGN_PROMPT'),
        });

        dialogResult.then((res) => {
            if (res) {
                this.removeCampaign(this.campaign);
            }
        });
    }

    removeCampaign(campaign) {
        this.showLoading();
        let loadParms = { campaignType: 'CAMPAIGN' };
        if (this.campaign.parent) {
            loadParms = { campaignType: 'MOTHER_CAMPAIGN' };
        }
        this.ApiCampaigns.deleteCampaign(campaign.campaignId).then((res) => {
            this.hideIonicLoading();
            if (res === null) {
                this.$state.go('campaigns', loadParms, { reload: true });
            }
        });
    }

    showLoading() {
        this.loading.push(1);
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>',
        });
    }

    hideIonicLoading() {
        let self = this;
        self.loading.pop();
        if (self.loading.length <= 0) self.$ionicLoading.hide();
    }

    getCurrencySymbol(currencyShortName) {
        if (!this.currencies || !currencyShortName) return '';

        var currency = this.currencies.find(function (currency) {
            return currency.shortName === currencyShortName;
        });

        return currency && currency.symbol;
    }

    redirectToEditPage() {
        if (this.campaign) {
            let state = this.campaign.parent
                ? 'motherCampaignEdit'
                : 'campaignEdit';
            this.$state.go(state, { campaignId: this.campaign.campaignId });
        }
    }

    onTabChange(type) {
        this.activeTab = type;
        this.$ionicScrollDelegate.scrollTop();
    }

    activityReportShow() {
        this.ApiCampaigns.getActivityReport(this.campaignId).then((data) => {
            let activityData = [];
            data.forEach((value) => {
                let item = activityData.find((item) => {
                    return item.code === value.levelOfInterest;
                });

                if (!item) {
                    item = {
                        code: value.levelOfInterest,
                        items: [],
                    };

                    activityData.push(item);
                }

                item.items.push(value);
            });

            this.activityReportData = activityData;
        });

        this.activityReportModal.show();
    }

    exportActivity() {
        this.sentEmailPopup.show(
            `${this.user.firstName} ${this.user.name}`,
            this.emailReport.bind(this)
        );
    }

    emailReport() {
        this.$ionicLoading.show();
        this.ApiCampaigns.emailActivities(this.campaignId).then((_) => {
            this.$ionicLoading.hide();
            this.MessageBox.showSuccessMessage(
                'EXPORT_ACTIVITY_REPORT',
                'SENT'
            );
        });
    }

    closeModal() {
        this.activityReportModal.hide();
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaignDetail.controller.js
 **/